import { API_BASE_URL } from '../config/api.js';
import { authHeaders } from '../lib/auth.js';

export async function checkStaffName(name) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/check-name`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, error: data.error };
}

export async function registerStaff(payload) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, data, error: data.error };
}

export async function loginStaff(username, password) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, data, error: data.error };
}

export async function sendStaffResetOtp(username, mobile) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/send-otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, mobile }),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, message: data.message, error: data.error };
}

export async function resetStaffPassword(payload) {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, message: data.message, error: data.error };
}

export async function fetchStaffProfile() {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/me`, {
    headers: { ...authHeaders() },
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, staff: data.staff, error: data.error };
}

export async function fetchSurveyData() {
  const res = await fetch(`${API_BASE_URL}/api/v1/staff/me/survey-data`, {
    headers: { ...authHeaders() },
  });
  const data = await res.json();
  return { ok: res.ok && data.ok, customers: data.customers ?? [], error: data.error };
}
